import dayjs, { Dayjs } from 'dayjs';

export const useDocCloseStatus = (date?:Dayjs|Date|string, periodInDays = 0) => {
  const today = dayjs().startOf('day');
  return date ? dayjs(date).add(periodInDays, 'day') < today || today < date : false;
};
